<template>
  <span>
    <template v-if="items.length > visibleItemsCount">
      <md-chip
        v-for="(item, index) in visibleItems"
        :key="`item-${index}`">
        {{ item.name }}
      </md-chip>
    </template>
    <md-chip
      v-if="items.length > visibleItemsCount"
      md-clickable>
      &hellip;
      <md-tooltip md-direction="top">{{ getItemsNames(hiddenItems).join(', ') }}</md-tooltip>
    </md-chip>
    <template v-if="items.length <= visibleItemsCount">
      <md-chip
        v-for="(item, index) in items"
        :key="`item-${index}`">
        {{ item.name }}
      </md-chip>
    </template>
  </span>
</template>

<script>
export default {
  name: 'TagsListWidget',
  props: {
    visibleItemsCount: {
      type: Number,
      default: 1
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    visibleItems () {
      var app = this
      return app.items.slice(0, app.visibleItemsCount)
    },
    hiddenItems () {
      var app = this
      return app.items.slice(app.visibleItemsCount)
    }
  },
  methods: {
    getItemsNames: function (items) {
      return items.map(x => x.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TagsListWidget.vue